import React from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

import { useTimeModal } from '../../TimeModal/TimeModalContext';

import Modal from '../../Modal';
import ChangeBalanceModal from '../../ChangeBalanceModal';

import LoadingBlock from '../../LoadingBlock';
import { formatBalance } from '../../../Utils/GlobalUtils';

const MyBalancePanel = ({ userId, isFromAccount, reload, setReload }) => {
    const { openTimeModal } = useTimeModal();

    const [balance, setBalance] = React.useState('Загрузка...');
    const [specialBalance, setSpecialBalance] = React.useState('Загрузка...');
    const [fioData, setFioData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');

    const [isAdmin, setIsAdmin] = React.useState(false);
            
    React.useEffect(() => {
        const token = localStorage.getItem('token');
    
        try {
            const decodedToken = jwtDecode(token);
            if (decodedToken.role==='АппаратСРО') {
                setIsAdmin(true);
            } else {
                setIsAdmin(false);
            }
        } catch (error) {
            console.error('Ошибка при декодировании токена: ', error);
        }
    }, []);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        setLoading(true);

        if (isFromAccount) {
            axios.get(`/api/get-important-account-data?userId=${userId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setFioData(response.data);
            }).catch((error) => {
                console.error('Ошибка при получении данных пользователя:', error);
            })
        }

        axios.get(`/api/get-user-balances?id=${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then((response) => {
            setWarning('');
            setBalance(response.data.balance);
            setSpecialBalance(response.data.special_balance);
        })
        .catch((error) => {
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        });
    }, [userId, reload]);

    const [isModal, setIsModal] = React.useState(false);


    return (
        <>
            <Modal isOpen={isModal} closeModal={() => setIsModal(false)}>
                <ChangeBalanceModal userId={userId} onSuccess={() => setReload(true)} />
            </Modal>

            <div className='boxPage'>
                <div className={`boxHeader ${balance < 0 ? 'boxAttention' : ''}`}>
                    <h3>Баланс {isFromAccount && (loading ? '(Загрузка...)' : `(${fioData.lastname} ${fioData.firstname} ${fioData.surname})`)}</h3>
                    {/* <img src='/img/branding/ruble-240.png' alt='Баланс' /> */}
                </div>
                <div className='boxMain'>
                    {loading ? <LoadingBlock width="100%" height="20px" /> : 
                    <>
                    <span
                        className='horizontalContainer'
                    >
                        <p className={`${balance < 0 && 'colorCell red'}`}>{formatBalance(balance) + ' ₽'} {balance < 0 && '(Задолженность)'}</p> <p className='description'>Членские взносы</p>
                    </span>
                    </>}
                    <div className='horizontalLine'></div>
                    {loading ? <LoadingBlock width="100%" height="20px" /> : 
                    <>
                    <span
                        className='horizontalContainer'
                    >
                        <p className={`${specialBalance < 0 && 'colorCell red'}`}>{formatBalance(specialBalance) + ' ₽'} {specialBalance < 0 && '(Задолженность)'}</p> <p className='description'>Целевые взносы</p>
                    </span>
                    </>}
                </div>
                <div className='boxFooter'>
                    {isAdmin ?
                        <button type='button' className='button' onClick={() => setIsModal(true)}>Взаимодействие со счётом</button>
                    : null}
                </div>
            </div>
        </>
    )
}

export default MyBalancePanel;